// src/components/whatsapp/WhatsAppFloat.jsx
import { useLocation } from "react-router-dom";
import { getWhatsAppLink } from "./getWhatsAppLink";

function WhatsAppFloat() {
  const location = useLocation();
  const waLink = getWhatsAppLink(location.pathname);

  return (
    <a
      href={waLink}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com a Cenovix no WhatsApp"
      title="Falar no WhatsApp"
    >
      <span className="whatsapp-float__icon" aria-hidden="true" />
      <span className="whatsapp-float__text">WhatsApp</span>
    </a>
  );
}

export default WhatsAppFloat;
